
























































































































































































































































import { defineComponent, onMounted, ref } from "@vue/composition-api";

import {
  SocialMediaApi,
  SocialMediaFileDto,
  SocialMediaFolderDto,
  SocialMediaType
} from "@/api";
import { downloadDocument } from "@/util/download";

export default defineComponent({
  name: "SocialMedia",
  setup() {
    const socialMediaApi = new SocialMediaApi();

    const media = ref<SocialMediaFolderDto[] | null>(null)

    const isPreviewImageOpen = ref(false)
    const isPreviewFolderOpen = ref(false)

    const previewImage = ref<SocialMediaFileDto | null | undefined>(null)
    const previewFolder = ref<SocialMediaFolderDto | null | undefined>(null)

    async function fetchSocialMediaImages() {
      const { data } = await socialMediaApi.socialMediaGetSocialMedia(SocialMediaType.EmployerSocialMedia)

      media.value = data
    }

    async function handleDownloadFolder(folderPath: string | null | undefined) {
      if (!folderPath) return

      const { data, headers } = await socialMediaApi.socialMediaDownloadSocialMediaFolder({
        socialMediaType: SocialMediaType.EmployerSocialMedia,
        folderPath,
      },
      {
        responseType: "arraybuffer",
      })

      downloadDocument(data, headers)
    }

    async function handleDownloadImage(fileName: string | null | undefined, folderPath: string | null | undefined) {
      if (!fileName || !folderPath) return

      const { data, headers } = await socialMediaApi.socialMediaDownloadSocialMediaFile({
        socialMediaType: SocialMediaType.EmployerSocialMedia,
        folderPath,
        fileName,
      },
      {
        responseType: "arraybuffer",
      })

      downloadDocument(data, headers)
    }

    async function handlePreviewFolder(folder: SocialMediaFolderDto) {
      isPreviewFolderOpen.value = true
      previewFolder.value = folder
    }

    async function handlePreviewImage(file: SocialMediaFileDto, folder: SocialMediaFolderDto) {
      isPreviewImageOpen.value = true
      previewImage.value = file
      previewFolder.value = folder
    }

    onMounted(() => {
      fetchSocialMediaImages()
    })

    return {
      isPreviewFolderOpen,
      isPreviewImageOpen,
      media,
      previewFolder,
      previewImage,
      handleDownloadFolder,
      handleDownloadImage,
      handlePreviewFolder,
      handlePreviewImage,
    };
  },
});
